import axios from '@/axios'
const BASE_URL = '/api/rental/public'
const api = {
  // get_code: `${BASE_URL}/User/Account/fastLoginSendcode`,
  get_code: `/api/community/public/common/sendtelcode`,
  login: `${BASE_URL}/Account/fastLogin`,
  logins: `/api/v2/user/user/passwdlogin`,
  register_code: `/api/community/public/Common/sendregmsg`,
  register: `/api/community/public/user/telreg`,
  info: `${BASE_URL}/User/User/find`,
  edit: `/api/v2/user/user/edit`,
  password: `${BASE_URL}/User/User/pUpdatePwd`,
  auth: `${BASE_URL}/Account/auth`
}

export const UserService = {
  getCode(data) {
    return axios.post(api.get_code, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  getRegisterCode(data) {
    return axios.post(api.register_code, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  login(data) {
    return axios.post(api.login, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  register(data) {
    return axios.post(api.register, data).then(res => {
      return Promise.resolve(res)
    })
  },
  idLogin(data) {
    return axios.post(api.logins, data).then(res => {
      return Promise.resolve(res)
    })
  },
  getInfo(data) {
    return axios.get(api.info, data).then(res => {
      return Promise.resolve(res)
    })
  },
  edit(data) {
    return axios.post(api.edit, data).then(res => {
      return Promise.resolve(res)
    })
  },
  editPassword(data) {
    return axios.post(api.password, data).then(res => {
      return Promise.resolve(res)
    })
  },
  auth() {
    return axios.post(api.auth).then(res => {
      return Promise.resolve(res)
    })
  }
}
export default UserService